import React, { useState, useEffect, useContext } from 'react';

import Swiper from 'react-id-swiper';
import { Pagination, Autoplay } from 'swiper';

import { LayoutContext } from '../../context/layoutContext';
import { BannerJoinHeader } from '../../styles/layOutStyles';
import Skeleton from '../../components/skeleton/Skeleton';

import BannerItem from './BannerItem';
import Header from '../Header';

import { connect } from 'react-redux';

const MainBanner = ({ bannerData }) => {
  const { matchese } = useContext(LayoutContext);

  const [swiper, setSwiper] = useState(null);
  const [play, setPlay] = useState(true);
  const [bannerList, setBannerList] = useState([]);

  let swiperPauseEle;

  useEffect(() => {
    if (bannerData.length > 0) {
      setBannerList(
        bannerData
          .filter(i => i.category === '상단메인')
          .filter(i => i.isShow)
          .sort((a, b) => (a?.createdAt < b?.createdAt ? 1 : -1)),
      );
    }
  }, [bannerData]);

  useEffect(() => {
    if (bannerList.length > 0) {
      const swiperInstance = document.querySelector('.swiper-container').swiper;
      const swiperPagination = document.querySelector('.swiper-pagination');

      let pauseEle = document.createElement('div');
      pauseEle.setAttribute('class', 'swiper-pauseEle');
      pauseEle.classList.add('pause');
      swiperPagination.append(pauseEle);

      setSwiper(swiperInstance);
    }
  }, [bannerList]);

  useEffect(() => {
    if (bannerList.length > 0) {
      swiperPauseEle = document.querySelector('.swiper-pauseEle');

      swiperPauseEle.addEventListener('click', onClickAutoPlayBtn);

      return () => swiperPauseEle.removeEventListener('click', onClickAutoPlayBtn);
    }
  }, [swiper, bannerList, play]);

  useEffect(() => {
    if (swiper) {
      let orgName = play ? 'play' : 'pause';
      let repName = play ? 'pause' : 'play';

      if (play) {
        swiper.autoplay.start();
      } else {
        swiper.autoplay.stop();
      }

      swiperPauseEle.classList.replace(orgName, repName);
    }
  }, [swiper, play]);

  const onClickAutoPlayBtn = () => {
    setPlay(!play);
  };

  const params = {
    modules: [Pagination, Autoplay],
    deceleration: 0.0005,
    speed: 1700,
    loop: true,
    autoplay: {
      delay: 10000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  };

  return (
    <>
      <BannerJoinHeader className='slider-area'>
        <Header logoShow={true} />
        {bannerList.length > 0 ? (
          <div style={{ padding: 0, position: 'relative', overflow: 'hidden' }}>
            <div className='slider-active-3 slider-hm8'>
              <Swiper {...params}>
                {bannerList
                  .filter(i => i.isShow)
                  .map((list, key) => {
                    return <BannerItem data={list} key={`${list.title}_${key}`} />;
                  })}
              </Swiper>
            </div>
          </div>
        ) : (
          <Skeleton id='bannerSkeleton' width='100%' height={matchese ? '390px' : '590px'} margin='0 0 15px' />
        )}
      </BannerJoinHeader>
    </>
  );
};

const mapStateToProps = state => {
  return {
    bannerData: state.bannerData.banner,
  };
};

export default connect(mapStateToProps)(MainBanner);
